import { COLORS } from "@store/theme/design";

export default {
    light20: `0 0 1px 0 ${COLORS.shadow.lighter}, 0 1px 3px 0 ${COLORS.shadow.light}`,
    light40: `0 0 1px 0 ${COLORS.shadow.lighter}, 0 2px 4px 0 ${COLORS.shadow.light}`,
    light60: `0 0 1px 0 ${COLORS.shadow.lighter}, 0 4px 8px 0 ${COLORS.shadow.light}`,
    light60Up: `0 0 1px 0 ${COLORS.shadow.lighter}, 0 -4px 8px 0 ${COLORS.shadow.light}`,
    light80: `0 0 1px 0 ${COLORS.shadow.lighter}, 0 8px 16px 0 ${COLORS.shadow.light}`,
    light100: `0 0 1px 0 ${COLORS.shadow.lighter}, 0 16px 24px 0 ${COLORS.shadow.light}`,
    dark20: `0 0 1px 0 ${COLORS.shadow.dark}, 0 1px 3px 0 ${COLORS.shadow.darker}`,
    dark40: `0 0 1px 0 ${COLORS.shadow.dark}, 0 2px 4px 0 ${COLORS.shadow.darker}`,
    dark60: `0 0 1px 0 ${COLORS.shadow.dark}, 0 4px 8px 0 ${COLORS.shadow.darker}`,
    dark80: `0 0 1px 0 ${COLORS.shadow.dark}, 0 8px 16px 0 ${COLORS.shadow.darker}`,
    dark100: `0 0 1px 0 ${COLORS.shadow.dark}, 0 16px 24px 0 ${COLORS.shadow.darker}`,
};
